// extracted by mini-css-extract-plugin
export var content = "_45-3";
export var list = "_45-4";
export var settingsContent = "_45-7";
export var settingsPanel = "_45-8";
export var state = "_45-6";
export var triggerBadge = "_45-2";
export var triggerButton = "_45-1";
export var triggerShell = "_45-0";
export var unreadDot = "_45-5";